import { useEffect, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { toastStyles, toastCSS } from "./Toast.style.js";

const Toast = ({ type = "success", title, description, show, onClose, duration = 5000 }) => {

  useEffect(() => {
    const styleId = "toast-component-styles";
    let styleElement = document.getElementById(styleId);

    if (!styleElement) {
      styleElement = document.createElement("style");
      styleElement.id = styleId;
      styleElement.textContent = toastCSS;
      document.head.appendChild(styleElement);
    }
  }, []);

  useEffect(() => {
    if (show && duration > 0) {
      const timer = setTimeout(() => {
        onClose?.();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  const handleClose = useCallback(
    (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      onClose?.();
    },
    [onClose]
  );

  const severity = useMemo(() => (type === "success" ? "success" : "error"), [type]);

  const anchorOrigin = useMemo(
    () => ({ vertical: "top", horizontal: "right" }),
    []
  );

  const alertTitleStyle = useMemo(
    () => toastStyles.alertTitle(!!description),
    [description]
  );

  return (
    <Snackbar
      open={show}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      className="toast-snackbar"
      style={toastStyles.snackbar}
    >
      <Alert onClose={handleClose} severity={severity} variant="filled" style={toastStyles.alert}>
        <AlertTitle style={alertTitleStyle}>{title}</AlertTitle>
        {description}
      </Alert>
    </Snackbar>
  );
};

Toast.propTypes = {
  type: PropTypes.oneOf(["success", "failure"]),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  duration: PropTypes.number,
};

export default Toast;

